module.exports = __webpack_public_path__ + "img/opp-plots.598466ac.png";